// WARNING: videoタグのmute属性はReactでは適用されないため、動画の音声をミュートにする場合は、動画ファイル自体をミュートにする必要があります。

// src/components/SearchModal/MySwiper.jsx
import { useRef, useEffect } from "react";
import { Swiper, globalSwiperSettings } from "../../utils/swiper";
import { Config } from "./Config";

const MySwiper = ({ value, options }) => {
 const swiperElRef = useRef(null);
 const prevButtonRef = useRef(null);
 const nextButtonRef = useRef(null);
 const prevButtonCustomRef = useRef(null);
 const nextButtonCustomRef = useRef(null);

 useEffect(() => {
  const swiperInstance = new Swiper(swiperElRef.current, {
   ...globalSwiperSettings,
   ...options,
   initialSlide: 0, // 1枚目を初期スライドとして設定（※0から数える）
   navigation: {
    prevEl: prevButtonRef.current,
    nextEl: nextButtonRef.current,
   },
   a11y: {
    containerMessage: "カルーセル",
    prevSlideMessage: "前のスライドへ",
    nextSlideMessage: "次のスライドへ",
    slideLabelMessage: "{{index}}枚目のスライド",
    paginationBulletMessage: "{{index}}枚目のスライドを表示",
    // firstSlideMessage: "最初のスライド",
    // lastSlideMessage: "最後のスライド",
   },
  });

  const handleKeyDown = (e) => {
   if ((e.key === "Enter" || e.key === " ") && document.activeElement) {
    if (document.activeElement === prevButtonRef.current || document.activeElement === prevButtonCustomRef.current) {
     swiperInstance.slidePrev();
    } else if (document.activeElement === nextButtonRef.current || document.activeElement === nextButtonCustomRef.current) {
     swiperInstance.slideNext();
    }
   }
  };

  prevButtonRef.current.addEventListener("click", () => swiperInstance.slidePrev());
  nextButtonRef.current.addEventListener("click", () => swiperInstance.slideNext());
  prevButtonRef.current.addEventListener("keydown", handleKeyDown);
  nextButtonRef.current.addEventListener("keydown", handleKeyDown);

  prevButtonCustomRef.current.addEventListener("click", () => swiperInstance.slidePrev());
  nextButtonCustomRef.current.addEventListener("click", () => swiperInstance.slideNext());
  prevButtonCustomRef.current.addEventListener("keydown", handleKeyDown);
  nextButtonCustomRef.current.addEventListener("keydown", handleKeyDown);

  // クリーンアップ処理: Swiper インスタンスの破棄（画像の順番が不安定なため）
  return () => {
   if (swiperInstance) {
    swiperInstance.destroy(true, true);
   }
  };
 }, [options, value.item_total_images_2, value.item_total_images_3, value.item_total_video]);

 const imgUrl = `/assets/images/item_photo/${value.item_inhouse_code}/`;
 const videoUrl = `/assets/videos/item_video/${value.item_inhouse_code}/`;
 const width = 550;
 const height = 550;

 // 1枚目の画像（th.jpg）を追加
 const image1 = {
  fileName: `th.jpg?${Config.cacheBuster}`,
  alt: `${value.item_number} ${value.item_color_en}`,
 };

 const images2 = [...Array(value.item_total_images_2).keys()].map((index) => ({
  fileName: `${index + 1}.jpg?${Config.cacheBuster}`,
  alt: `${value.item_number} ${value.item_color_en} ${index + 1}`,
 }));

 const images3 = [...Array(value.item_total_images_3).keys()].map((index) => ({
  fileName: `${value.item_inhouse_code}_${index + 1}.jpg?${Config.cacheBuster}`,
  alt: `${value.item_number} ${value.item_color_en} ${index + 1 + value.item_total_images_2}`,
 }));

 const videos = [...Array(value.item_total_video).keys()].map((index) => ({
  fileName: `${index + 1}.webm?${Config.cacheBuster}`,
  fileNameFallback: `${index + 1}.mp4?${Config.cacheBuster}`,
  alt: `${value.item_number} ${value.item_color_en} + "の動画"`,
 }));

 // 全ての画像を配列に追加（th.jpg を最初に追加）
 const allImagesWithVideos = [image1, ...videos, ...images2, ...images3];
 // フィルター処理で fileName が空文字の場合は除外
 const validMedia = allImagesWithVideos.filter((item) => item.fileName !== "");

 // ログを追加して画像の順番を確認
 //  console.log("All Images in Swiper:", allImages);

 return (
  <>
   <div className="p-item-modal__slider-wrap">
    <div ref={swiperElRef} className="p-item-modal__slider-container swiper">
     <div className="swiper-wrapper">
      {validMedia.map((item, index) => {
       const imageUrl = imgUrl + item.fileName; // 画像URLを生成
       return (
        <div key={index} className="swiper-slide">
         {item.fileName.includes(".webm") ? ( // 動画の場合
          <>
           <div className="p-item-modal__icon--360view">
            <img src="/assets/images/common/icon/icon_slider_360view.png" alt="360° View" width="132" height="132" loading="lazy" />
           </div>
           <video width={width} height={height} loop playsInline autoPlay muted={true} preload="metadata">
            <source src={videoUrl + item.fileName} type="video/webm" />
            <source src={videoUrl + item.fileNameFallback} type="video/mp4" />
           </video>
          </>
         ) : (
          // 画像の場合
          <>
           <img src={imageUrl} alt={item.alt} width={width} height={height} loading="lazy" />
           <div className="swiper-lazy-preloader"></div>
          </>
         )}
        </div>
       );
      })}
     </div>
     {/* {value.item_badge && (
      <>
       {value.item_badge === "New" && (
        <span className="p-card__badge p-card__badge--new">
         <span className="sr-only">{value.item_badge}</span>
        </span>
       )}
       {value.item_badge === "Limited" && (
        <span className="p-card__badge p-card__badge--limited">
         <span className="sr-only">{value.item_badge}</span>
        </span>
       )}
       {value.item_badge === "Sale" && (
        <span className="p-card__badge p-card__badge--sale">
         <span className="sr-only">{value.item_badge}</span>
        </span>
       )}
      </>
     )} */}
    </div>
    <div className="swiper-button-prev swiper-button-prev-outside" tabIndex="0" role="button" ref={prevButtonRef}></div>
    <div className="swiper-button-next swiper-button-next-outside" tabIndex="0" role="button" ref={nextButtonRef}></div>
    {value.item_total_video + value.item_total_images_2 + value.item_total_images_3 > 1 && (
     <div className="swiper-button-custom">
      <div className="swiper-button-prev swiper-button-prev-custom" tabIndex="0" role="button" ref={prevButtonCustomRef}></div>
      <div className="swiper-pagination swiper-pagination-custom"></div>
      <div className="swiper-button-next swiper-button-next-custom" tabIndex="0" role="button" ref={nextButtonCustomRef}></div>
     </div>
    )}
   </div>
  </>
 );
};

export default MySwiper;
